'use strict';

export function SelectOption(selectValue, viewValue, label, group, disabled, className, icon) {
  this.selectValue = selectValue;
  this.viewValue = viewValue;
  this.label = label;
  this.group = group;
  this.disabled = disabled;
  this.className = className;
  this.icon = icon;
}



// WEBPACK FOOTER //
// ./src/js/core-components/popover-select/SelectOption.js